console.info('Version', process.env.VERSION);

function onLoad() {
    Promise.all([
        import(/* webpackChunkName: "helpers/i18n" */ 'helpers/i18n'),
        import(/* webpackChunkName: "pages/index" */ 'Pages/Index/Index'),
    ])
        .then(([, { default: loadIndex }]) => {
            loadIndex(window.reactProps);
        })
        .catch((error) => {
            console.error('Error loading modules:', error);
        });
}

// Use the window load event to keep the page load performant
window.addEventListener('load', onLoad);
